<template>
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M0 10.667 8 4l4 2 4-2 8 6.667S20.667 20 14 20h-4c-6.667 0-10-9.333-10-9.333m2.667 0s3.333 4 9.333 4 9.333-4 9.333-4l-6-1.334S13.33 10 12 10s-3.333-.667-3.333-.667z"/></svg>
</template>